export default "__VITE_ASSET__DCQA794V__"